
<button class="btn btn-outline-lines" *ngIf="actived>min" (click)="select(actived-1)">{{'button.before' | translate}}</button>
<button class="btn btn-outline-lines" (click)="downRange()" *ngIf="hasLess">...</button>
<ng-template ngFor [ngForOf]="numbers" let-n let-i="index">
  <button [ngClass]="actived+1==n ? 'btn btn-outline-lines actived' : 'btn btn-outline-lines'" *ngIf="i>=min && i<=max" (click)="select(n-1)">{{n}}</button>
</ng-template>
<button class="btn btn-outline-lines" (click)="upRange()" *ngIf="hasMore">...</button>
<button class="btn btn-outline-lines" *ngIf="hasMore">{{pages}}</button>
<button class="btn btn-outline-lines" *ngIf="actived<max" (click)="select(actived+1)">{{'button.next' | translate}}</button>
